export default __webpack_public_path__ + "static/Inter-Regular-e63a5bf428ac4208f056f0d3d6b3e64f.woff2";